import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df7c058a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tickets__container" }
const _hoisted_2 = { class: "tickets__title title" }
const _hoisted_3 = { class: "tickets__text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "prices__title title--small" }, "Prijzen", -1))
const _hoisted_5 = {
  key: 0,
  class: "tickets__title title--small"
}
const _hoisted_6 = {
  key: 1,
  class: "tickets__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DisplayType = _resolveComponent("DisplayType")!
  const _component_PriceTable = _resolveComponent("PriceTable")!
  const _component_page_section = _resolveComponent("page-section")!
  const _component_BackgroundWrapper = _resolveComponent("BackgroundWrapper")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_BackgroundWrapper, {
    backgroundColor: "yellow",
    "extra-margin": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_page_section, { class: "tickets section--backgroundcolor section--yellow" }, {
        default: _withCtx(() => [
          _createVNode(_component_DisplayType, {
            class: _normalizeClass(`tickets__display_title tickets__display_title-${_ctx.randomClassNameSuffix}`),
            line1: "Koop kaartjes",
            line1MaskHeight: 100,
            line1Indent: -0.2,
            line2: "voor het",
            line2MaskHeight: 66,
            line2Indent: -0.4,
            line3: "museum",
            line3MaskHeight: 75,
            line3Indent: 1,
            animateTitle: false,
            elementType: "h2"
          }, null, 8, ["class", "line1Indent", "line2Indent"]),
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createElementVNode("h2", _hoisted_2, null, 512), [
              [_directive_sanitize, _ctx.title]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
              [_directive_sanitize, _ctx.text]
            ]),
            _hoisted_4,
            _createVNode(_component_PriceTable, { prices: _ctx.prices }, null, 8, ["prices"]),
            (_ctx.extraTitle && _ctx.extraTitle !== '')
              ? _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_5, null, 512)), [
                  [_directive_sanitize, _ctx.extraTitle]
                ])
              : _createCommentVNode("", true),
            (_ctx.extraText && _ctx.extraText !== '')
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, null, 512)), [
                  [_directive_sanitize, _ctx.extraText]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}